
import { motion } from "framer-motion";
import {

    AccordionItem,

} from "./ui/accordion";
import { FAQS } from "../lib/data";

export const FAQ = () => {
    const prefix = "//";
    return (
        <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-4">
                            {prefix} Common Questions
                        </div>
                        <h2 className="text-4xl sm:text-5xl font-bold tracking-tighter">
                            Things <span className="text-gradient-cyan">people ask</span>.
                        </h2>
                        <p className="mt-5 text-slate-400 leading-relaxed">
                            Don't see your question? Drop me a WhatsApp message. I usually reply within an hour.
                        </p>
                    </div>
                    <div className="lg:col-span-8">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            {/* <Accordion type="single" collapsible className="w-full"> */}
                            {/* {FAQS.map((f, i) => (
                                    <AccordionItem
                                        key={i}
                                        value={`item-${i}`}
                                        data-testid={`faq-item-${i}`}
                                        className="border-b border-white/10 last:border-b-0"
                                    >
                                        <AccordionTrigger
                                            data-testid={`faq-trigger-${i}`}
                                            className="text-left py-6 text-base md:text-lg font-semibold hover:text-cyan-400 hover:no-underline"
                                        >
                                            {f.q}
                                        </AccordionTrigger>
                                        <AccordionContent className="text-slate-400 text-[15px] leading-relaxed pb-6">
                                            {f.a}
                                        </AccordionContent>
                                    </AccordionItem>
                                ))} */}

                            {FAQS.map((f, i) => (
                                <AccordionItem key={i} title={f.q}>
                                    {f.a}
                                </AccordionItem>
                            ))}
                            {/* </Accordion> */}
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};
